import { ModalCustom, Icon, XIcon } from '@/components';
import Router from 'next/router';
import React, { useEffect, useState } from 'react';
import { useMasterDataPopupQuery } from '../api';

// Popup khuyến mãi: mỗi chương trình chỉ hiện 1 lần / trình duyệt, và không hiện cho bot (Googlebot, Lighthouse…)
const POPUP_SEEN_KEY = 'promo_popup_seen';
const BOT_UA = /bot|crawl|spider|slurp|lighthouse|headless|inspectiontool|facebookexternalhit|bingpreview|mediapartners|adsbot/i;
const isBot = () => {
  if (typeof navigator === 'undefined') return true;
  return BOT_UA.test(navigator.userAgent) || (navigator as any).webdriver === true;
};
const popupKey = (data: any) => String(data?.id ?? '') + '|' + (data?.title ?? '') + '|' + (data?.mobile_extra?.image_url ?? '');
const getSeen = () => {
  try { return localStorage.getItem(POPUP_SEEN_KEY); } catch { return null; }
};
const markSeen = (key: string) => {
  try { localStorage.setItem(POPUP_SEEN_KEY, key); } catch { /* bỏ qua */ }
};

export const PopupPartial = () => {
  const [show, setShow] = useState<boolean>(false);
  const [popupData, setPopupData] = useState<any>(null);
  const { refetch } = useMasterDataPopupQuery({
    enabled: false,
    retry: false,
    refetchOnWindowFocus: false,
    onSuccess: ({ data }) => {
      if (!data?.title) return setShow(false);
      const key = popupKey(data);
      // đã xem chương trình này rồi → không hiện lại; chương trình mới (ảnh/tiêu đề khác) sẽ hiện 1 lần
      if (getSeen() === key) return setShow(false);
      markSeen(key);
      setShow(true);
      setPopupData(data);
    },
  });
  const redirect = () => {
    Router.push(popupData.link);
    setShow(false);
  };
  useEffect(() => {
    if (isBot()) return;
    refetch();
  }, [refetch]);
  if (!show) return <></>;
  return (
    <ModalCustom
      className="!tw-p-0 !tw-w-auto !tw-max-w-[92vw] md:!tw-max-w-[1000px] !tw-bg-transparent"
      childrenClass="!tw-gap-y-0 tw-items-center"
    >
      {/* khung ôm sát ảnh (theo đúng tỉ lệ ảnh) → nút X luôn nằm ở góc ảnh, dù ảnh vuông, dọc hay ngang */}
      <div className="tw-relative tw-inline-block tw-rounded-2xl tw-overflow-hidden tw-leading-none">
        <button
          type="button"
          aria-label="Đóng"
          className="tw-absolute tw-top-2 tw-right-2 tw-w-9 tw-h-9 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-black/40 tw-border-none tw-p-0 tw-z-1 tw-cursor-pointer"
          style={{ color: popupData?.web_extra?.icon_cancel_color || '#fff' }}
          onClick={() => setShow(false)}
        >
          <Icon className="tw-w-4 tw-h-4" icon={<XIcon />} />
        </button>
        <div onClick={redirect} className="tw-cursor-pointer">
          <picture>
            {popupData?.web_extra?.image_url && (
              <source media="(min-width: 768px)" srcSet={popupData.web_extra.image_url} />
            )}
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={popupData?.mobile_extra?.image_url || popupData?.web_extra?.image_url}
              alt={popupData?.title}
              className="tw-block tw-w-auto tw-h-auto tw-max-w-[92vw] md:tw-max-w-[1000px] tw-max-h-[80vh] tw-object-contain"
            />
          </picture>
        </div>
      </div>
    </ModalCustom>
  );
};
